import { render, staticRenderFns } from "./kw_signature_pad.vue?vue&type=template&id=27045f24&scoped=true&"
import script from "./kw_signature_pad.vue?vue&type=script&lang=js&"
export * from "./kw_signature_pad.vue?vue&type=script&lang=js&"
import style0 from "./kw_signature_pad.vue?vue&type=style&index=0&id=27045f24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27045f24",
  null
  
)

component.options.__file = "kw_signature_pad.vue"
export default component.exports